/** @license React v16.6.0
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: !0
});
var c = null,
    f = 3,
    h = -1,
    k = -1,
    l = !1,
    m = !1,
    n = "object" === typeof performance && "function" === typeof performance.now,
    q = {
  timeRemaining: n ? function () {
    if (null !== c && c.expirationTime < k) return 0;
    var a = p() - performance.now();
    return 0 < a ? a : 0;
  } : function () {
    if (null !== c && c.expirationTime < k) return 0;
    var a = p() - Date.now();
    return 0 < a ? a : 0;
  },
  didTimeout: !1
};

function r() {
  if (!l) {
    var a = c.expirationTime;
    m ? t() : m = !0;

    _u(v, a);
  }
}

function w() {
  var a = c,
      b = c.next;
  if (c === b) c = null;else {
    var d = c.previous;
    c = d.next = b;
    b.previous = d;
  }
  a.next = a.previous = null;
  d = a.callback;
  b = a.expirationTime;
  a = a.priorityLevel;
  var e = f,
      R = k;
  f = a;
  k = b;

  try {
    var g = d(q);
  } finally {
    f = e, k = R;
  }

  if ("function" === typeof g) if (g = {
    callback: g,
    priorityLevel: a,
    expirationTime: b,
    next: null,
    previous: null
  }, null === c) c = g.next = g.previous = g;else {
    d = null;
    a = c;

    do {
      if (a.expirationTime >= b) {
        d = a;
        break;
      }

      a = a.next;
    } while (a !== c);

    null === d ? d = c : d === c && (c = g, r());
    b = d.previous;
    b.next = d.previous = g;
    g.next = d;
    g.previous = b;
  }
}

function x() {
  if (-1 === h && null !== c && 1 === c.priorityLevel) {
    l = !0;
    q.didTimeout = !0;

    try {
      do {
        w();
      } while (null !== c && 1 === c.priorityLevel);
    } finally {
      l = !1, null !== c ? r() : m = !1;
    }
  }
}

function v(a) {
  l = !0;
  q.didTimeout = a;

  try {
    if (a) for (; null !== c;) {
      var b = exports.unstable_now();

      if (c.expirationTime <= b) {
        do {
          w();
        } while (null !== c && c.expirationTime <= b);
      } else break;
    } else if (null !== c) {
      do {
        w();
      } while (null !== c && 0 < p() - exports.unstable_now());
    }
  } finally {
    l = !1, null !== c ? r() : m = !1, x();
  }
}

var y = Date,
    z = "function" === typeof setTimeout ? setTimeout : void 0,
    A = "function" === typeof clearTimeout ? clearTimeout : void 0,
    B = "function" === typeof requestAnimationFrame ? requestAnimationFrame : void 0,
    C = "function" === typeof cancelAnimationFrame ? cancelAnimationFrame : void 0,
    D,
    E;

function F(a) {
  D = B(function (b) {
    A(E);
    a(b);
  });
  E = z(function () {
    C(D);
    a(exports.unstable_now());
  }, 100);
}

if (n) {
  var G = performance;

  exports.unstable_now = function () {
    return G.now();
  };
} else exports.unstable_now = function () {
  return y.now();
};

var _u, t, p;

if ("undefined" !== typeof window && window._schedMock) {
  var H = window._schedMock;
  _u = H[0];
  t = H[1];
  p = H[2];
} else if ("undefined" === typeof window || "function" !== typeof window.addEventListener) {
  var I = null,
      J = -1,
      K = function K(a, b) {
    if (null !== I) {
      var d = I;
      I = null;

      try {
        J = b, d(a);
      } finally {
        J = -1;
      }
    }
  };

  _u = function u(a, b) {
    -1 !== J ? setTimeout(_u, 0, a, b) : (I = a, setTimeout(K, b, !0, b), setTimeout(K, 1073741823, !1, 1073741823));
  };

  t = function t() {
    I = null;
  };

  p = function p() {
    return Infinity;
  };

  exports.unstable_now = function () {
    return -1 === J ? 0 : J;
  };
} else {
  "undefined" !== typeof console && ("function" !== typeof B && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"), "function" !== typeof C && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"));
  var L = null,
      M = !1,
      N = -1,
      O = !1,
      P = !1,
      Q = 0,
      S = 33,
      T = 33;

  p = function p() {
    return Q;
  };

  var U = "__reactIdleCallback$" + Math.random().toString(36).slice(2);
  window.addEventListener("message", function (a) {
    if (a.source === window && a.data === U) {
      M = !1;
      a = L;
      var b = N;
      L = null;
      N = -1;
      var d = exports.unstable_now(),
          e = !1;
      if (0 >= Q - d) if (-1 !== b && b <= d) e = !0;else {
        O || (O = !0, F(V));
        L = a;
        N = b;
        return;
      }

      if (null !== a) {
        P = !0;

        try {
          a(e);
        } finally {
          P = !1;
        }
      }
    }
  }, !1);

  var V = function V(a) {
    if (null !== L) {
      F(V);
      var b = a - Q + T;
      b < T && S < T ? (8 > b && (b = 8), T = b < S ? S : b) : S = b;
      Q = a + T;
      M || (M = !0, window.postMessage(U, "*"));
    } else O = !1;
  };

  _u = function _u(a, b) {
    L = a;
    N = b;
    P || 0 > b ? window.postMessage(U, "*") : O || (O = !0, F(V));
  };

  t = function t() {
    L = null;
    M = !1;
    N = -1;
  };
}

exports.unstable_ImmediatePriority = 1;
exports.unstable_UserBlockingPriority = 2;
exports.unstable_NormalPriority = 3;
exports.unstable_IdlePriority = 4;

exports.unstable_runWithPriority = function (a, b) {
  switch (a) {
    case 1:
    case 2:
    case 3:
    case 4:
      break;

    default:
      a = 3;
  }

  var d = f,
      e = h;
  f = a;
  h = exports.unstable_now();

  try {
    return b();
  } finally {
    f = d, h = e, x();
  }
};

exports.unstable_scheduleCallback = function (a, b) {
  var d = -1 !== h ? h : exports.unstable_now();
  if ("object" === typeof b && null !== b && "number" === typeof b.timeout) b = d + b.timeout;else switch (f) {
    case 1:
      b = d + -1;
      break;

    case 2:
      b = d + 250;
      break;

    case 4:
      b = d + 1073741823;
      break;

    default:
      b = d + 5E3;
  }
  a = {
    callback: a,
    priorityLevel: f,
    expirationTime: b,
    next: null,
    previous: null
  };
  if (null === c) c = a.next = a.previous = a, r();else {
    d = null;
    var e = c;

    do {
      if (e.expirationTime > b) {
        d = e;
        break;
      }

      e = e.next;
    } while (e !== c);

    null === d ? d = c : d === c && (c = a, r());
    b = d.previous;
    b.next = d.previous = a;
    a.next = d;
    a.previous = b;
  }
  return a;
};

exports.unstable_cancelCallback = function (a) {
  var b = a.next;

  if (null !== b) {
    if (b === a) c = null;else {
      a === c && (c = b);
      var d = a.previous;
      d.next = b;
      b.previous = d;
    }
    a.next = a.previous = null;
  }
};

exports.unstable_wrapCallback = function (a) {
  var b = f;
  return function () {
    var d = f,
        e = h;
    f = b;
    h = exports.unstable_now();

    try {
      return a.apply(this, arguments);
    } finally {
      f = d, h = e, x();
    }
  };
};

exports.unstable_getCurrentPriorityLevel = function () {
  return f;
};